<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="confirmModel" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="confirmModel = false">Disagree</v-btn>
            <v-btn
            color="green darken-1"
            flat="flat"
            @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <MethodStepsForm :formSchema="formSchema" :procurement_type_list="procurement_type_list" v-on:emitCloseModal="close"></MethodStepsForm>

    <v-card-title>
      <h2> Method Steps List</h2>

      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-autocomplete            
      label="Procurement Type"
      :items="procurement_type_list"
      item-text="name"
      item-value="id"
      clearable
      single-line hide-details  
      @change="setType($event)"
      ></v-autocomplete>
      <v-spacer></v-spacer>
      <v-autocomplete            
      label="Method Name"
      :items="filteredMethod"
      item-text="name"
      item-value="id"
      clearable
      single-line hide-details         
      v-model="method_id"
      @change="findByMethod(method_id)"
      ></v-autocomplete>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>

    <v-data-table
    v-bind:headers="headers"
    v-bind:items="items"
    v-bind:search="search"
    v-bind:pagination.sync="pagination"
    :total-items="totalItems"
    :loading="loading"
    class="elevation-1"
    >
    <template slot="items" slot-scope="props">
      <td class="text-xs-left">{{ ++(props.index) }}</td>
      <td class="text-xs-left">{{ props.item.step_name }}</td>
      <td class="text-xs-left">{{ props.item.step_name_bn }}</td>
      <td class="text-xs-left">{{ props.item.step_serial }}</td>
      <td class="text-xs-left">{{ props.item.report_serial }}</td>
      <td class="text-xs-left">
        <span v-if="props.item.is_supplier" class="active">Yes</span>
              <span v-else class="in-active">No</span>
      </td>
      <td class="text-xs-left">
        <span v-if="props.item.active" class="active">Yes</span>
              <span v-else class="in-active">No</span>
      </td>

      <td class="justify-center layout px-0">
        <v-btn icon class="mx-0"  @click="editItem(props.index, props.item)">
          <v-icon color="teal">edit</v-icon>
        </v-btn>
        <v-btn icon class="mx-0"  @click="deleteItem(props.index, props.item.id)">
          <v-icon color="pink">delete</v-icon>
        </v-btn>
      </td>
    </template>

    <template slot="no-data" class="error">
       <div align="center"> No Data Found</div>
    </template>
  </v-data-table>

<!-- {{items}} -->
</div>
</template>

<script>
  let commonService = require("../../../services/common.service");

  import MethodStepsForm from "./methodStepsForm.vue";
  export default {
    components: {
      MethodStepsForm
    },

    data: () => ({
      dialog: false,
      totalItems: 0,
      loading: true,
      methodNameList:[],
      procurement_type_list: [],
      filteredMethod:[],
      pagination: {
        sortBy: "id",
        descending: true
      },
      search: "",

      headers: [
      {
        text: "SL",
        align: "left",
        sortable: true,
        value: "id"
      },

      {
        text: "Step Name",
        align: "left",
        value: "step_name"
      },
      {
        text: "Step Name (Bangla)",
        align: "left",
        value: "step_name_bn"
      },
      {
        text: "Step Serial",
        align: "left",
        value: "step_serial"
      },
      {
        text: "Report Serial",
        align: "left",
        value: "report_serial"
      },
      {
        text: "Supplier / Firm & Consultant",
        align: "left",
        value: "is_supplier"
      },
      {
        text: "Active",
        align: "left",
        value: "active"
      },
      {
        text: "Action",
        align: "left",
        value: ""
      }
      ],

      items: [],

      delete_id: "",
      row_index: "",
      confirmModel: false,
      snackbar: false,
      color: "success",
      mode: "",
      timeout: 3000,
      left: "left",
      message: "",

      leaveTypeModal: false,
      formSchema: {
        id:'',
        p_type_id:'',
        method_id:'',
        method_name:'',
        step_name:'',
        step_name_bn:'',
        step_serial:'',
        report_serial:'',
        is_supplier:'',
        is_report:'',
        Active:''
      },

      queryData: {
        sortBy: "id",
        descending: false,
        page: 1,
        rowsPerPage: 10,
        search_val: ""
      },
      SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },
    }),

    computed: {
      userRole() {
        return this.$store.getters.get_USER_ROLE_DATA;
      }
    },

    mounted() {
      this.loadData();
      this.message = "Data loading!";
      this.snackbar = true;
    },

    created () {
      commonService.getAllData('proc_methods_list').then( res => { 
      if(res.status == 1)
      {
        this.methodNameList = res.data;
      }               
      });
      commonService.getAllData("proc_get_types").then((res) => {
       this.procurement_type_list = res.data;
      });
    },

    methods: {
      loadData(pagination) {
        commonService.getAllData("proc_method_steps").then(res => {
          this.items = res.data;
          this.loading = false;
        });
      },

      setType(e) {
          let curId = e
         
        this.filteredMethod = this.methodNameList.filter((item) => item.p_type_id == curId)
      },

      findByMethod(id){ 
        commonService.getAllDataById(id,'search_proc_method_steps').then(res => {
          this.items = res.data;
          console.log(res.data);
          this.loading = false;
        }); 
      },

      editItem(index, data) {

        this.row_index = index;
        this.formSchema = data;
        window.scrollTo({
          top: 0,
          left: 100,
          behavior: "smooth"
        });
        console.log(this.formSchema);
      },

      deleteItem(index, id) {
        this.row_index = index;
        this.delete_id = id;
        this.confirmModel = true;
      },

      confirmDelete(row_index, id) {
        commonService.deleteRow(id, "proc_method_steps").then(res => {
          if (res.status == 1) {
          this.items.splice(row_index, 1);
          this.loadData()
          } else {
          this.SnackbarVal.color = "error";
          }
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;

        this.confirmModel = false;
        this.dialog2 = false;
        });
      },


      close(res) {
        let $this = this;
        if (res.status == 1) {
          if (res.action == "add") {
            $this.items.unshift({ ...res.data });
          }
          if (res.action == "edit") {  
            let findindex = this.items.findIndex((item) => item.id == res.data.id)      
            this.row_index = findindex        
            this.$set(this.items, this.row_index, { ...res.data })
            this.row_index = "";
            this.formSchema.id = 0
            
          }
          window.scrollTo({
            left: 0,
            top:
              document.body.scrollHeight || document.documentElement.scrollHeight,
              behavior: "smooth"
          });
        }
          this.SnackbarVal.color = "success";
        this.SnackbarVal.message = res.message;
       this.SnackbarVal.snackbar = true;
      },

    }
  };
</script>



// WEBPACK FOOTER //
// src/components/procurement/method_steps/method_steps_list.vue